import React, { useState } from "react";
import CommonTableTwoLine from "../../../components/common/common-table/common-table-two-line";
import ProductionOverrunColumnModel from "./production-overrun-column-model";
import { ApiRequest } from "../../../services/api/api";
import CommonDialog from "../../../components/common/others/common-dialog";
import ProductionOverrunEditDialog from "./production-overrun-edit-dialog";

const ProductionOverrunReportPage: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [editOpen, setEditOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);

  const fetchData = async () => {
    try {
      console.log("Fetching production overrun summary...");
      const result = await ApiRequest({
        otherUrl: "ProductionOverrunReport/GetProductionOverrunSummary",
        method: "get",
        isShowSpinner: true,
      });
      console.log("Production overrun summary result:", result);
      setData(result?.data?.data || []);
    } catch (error: any) {
      console.error("Failed to load production overrun summary", error);
      console.error("Error details:", {
        message: error?.message,
        response: error?.response,
        url: error?.config?.url,
        fullUrl: error?.config?.baseURL + error?.config?.url
      });
      setData([]);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  const handleEditClick = (rowData: any) => {
    setSelectedProduct({
      productId: rowData.productId,
      productName: rowData.productName,
      currentQuantity: rowData.totalOverrunQuantity || 0,
    });
    setEditOpen(true);
  };

  const handleEditSuccess = () => {
    setEditOpen(false);
    setSelectedProduct(null);
    // 刷新数据
    fetchData();
  };

  const handleEditCancel = () => {
    setEditOpen(false);
    setSelectedProduct(null);
  };

  return (
    <div>
      <CommonTableTwoLine
        title="产品超额生产报告 / Production Overrun Report"
        column={ProductionOverrunColumnModel({ onEditClick: handleEditClick })}
        initData={data}
        editable={false}
        isNotAddable={true}
        isNotEditable={true}
        isNotDeletable={true}
        defaultPageSize={20}
        defaultPageSizeOptions={[10, 20, 50, 100]}
      />
      <CommonDialog
        open={editOpen}
        title={`编辑累计多出数量 / Edit Total Overrun Quantity - ${selectedProduct?.productName || ""}`}
        onDialogClose={handleEditCancel}
        dialogContent={
          selectedProduct ? (
            <ProductionOverrunEditDialog
              productId={selectedProduct.productId}
              productName={selectedProduct.productName}
              currentQuantity={selectedProduct.currentQuantity}
              onSuccess={handleEditSuccess}
              onCancel={handleEditCancel}
            />
          ) : null
        }
        width="600px"
      />
    </div>
  );
};

export default ProductionOverrunReportPage;

